module.exports = __webpack_public_path__ + "img/area.0bb97cd6.png";